import React from 'react';
import { render } from 'react-dom';
import { DialogProvider } from '../../components/Dialog/DialogProvider';
import { StoreSelectorBanner } from '../../components/StoreSelectorBanner';

export const initializeStoreSelector = () => {
  const root = document.querySelector('#store-selector');
  render(
    <DialogProvider>
      <StoreSelectorBanner />
    </DialogProvider>,
    root,
  );
};
